import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Input from '../CustomInputs/Input';
import Phone from '../CustomInputs/Phone';
import PhoneInternational from '../CustomInputs/PhoneInternational';
import CNPJ from '../CustomInputs/CNPJ';
import CPF from '../CustomInputs/CPF';
import Select from "../CustomInputs/Select";
import SelectIcons from "../CustomInputs/SelectIcons";
import DateField from "../CustomInputs/DateField";
import TimeField from "../CustomInputs/TimeField";
import CustomCheckBox from "../CustomInputs/CustomCheckBox";
import Address from "../CustomInputs/Address";
import SortableTree from "../CustomInputs/SortableTree";
import JsonInput from "../CustomInputs/JsonInput";
import FileUpload from "../CustomInputs/FileUpload";
import Integer from "../CustomInputs/Integer";
import WhatsAppQRCODE from "../CustomInputs/WhatsAppQRCODE";
import MultiInput from "../CustomInputs/MultiInput";
import Decimal from "../CustomInputs/Decimal";
import Toast from '../../../Util/Toast/Toast';
import validate from 'validate.js';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import Fetch from '../../../functions/Fetch';
import { useBasePath } from '../../../functions/Path';
import { formatCurrency } from '../../../functions/Currency';
import { useSelector, useDispatch } from 'react-redux';
import './CustomForm.css';
import { allIcons } from "./fontAwesomeIcons";
import MultiSelect from "../CustomInputs/MultiSelect";
import QRCode from "react-qr-code";
import FileUploadS3 from "../CustomInputs/FileUploadS3";
import MultiFileUploadS3 from "../CustomInputs/MultiFileUploadS3";
import DateTimeField from "../CustomInputs/DateTimeField";
import MultiApiSearch from "../CustomInputs/MultiApiSearch";
import Year from "../CustomInputs/Year";

function CustomForm(props) {

    const dispatch = useDispatch();
    const session = useSelector((state) => { return state.core.session });
    const path = useBasePath();

    let { id } = useParams();
    id = props.form.id ? props.form.id : id;

    const iconsOptions = allIcons.map((icon) => {
        return { value: `nav-icon ${icon}`, label: icon }
    });

    const navigate = useNavigate();
    let defaultPropsForm = {
        labelTitle: '',
        containerType: 'container',
        endpointSave: '',
        endpointTypeRequest: 'put',
        urlGoBack: '',
        handleSubmit: false,
        showGoBackButton: true,
        showSubmitButton: true,
        showContainerButtons: true,
        validateOnChange: false,
        hiddenValues: {},
        afterSubmit: (form, values) => {
            if (props.form.containerType == 'dialog') {
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
            } else {
                navigate(props.form.urlGoBack);
            }
        },
        form: [],
        customValidators: {}
    }

    if (path == props.form.pathView) {
        defaultPropsForm.showSubmitButton = false;
        defaultPropsForm.readOnly = true;
    }

    let [form, setForm] = useState({ ...defaultPropsForm, ...props.form });
    let [fields, updateFields] = useState([]);
    let inputs = {};
    let [values, updateValues] = useState({});
    let [errors, updateErrors] = useState({});

    useEffect(() => {
        const loadForm = async () => {
            dispatch({ type: 'SHOW_LOADING', value: true });
            let formValues = props.form.values;
            let formFields = props.form.fields;
            if (
                props.form.endpointGetById
                && id
                && !formValues
            ) {
                let postData = { id: id };
                let response = await Fetch.post(props.form.endpointGetById, postData);
                formValues = response;
            }
            let inputs = prepareValuesToLoad(formFields, formValues);
            updateValues(inputs);
            updateFields(formFields);
            dispatch({ type: 'SHOW_LOADING', value: false });
            dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: formValues ? formValues : {} });
        }
        loadForm();
    }, []);


    const goBack = () => {
        if (form.containerType == 'dialog') {
            dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
        } else {
            navigate(form.urlGoBack);
        }
    }

    const handleChange = (element, field) => {
        let tempValues = values;
        tempValues[element.target.name] = element.target.value;
        updateValues(tempValues);
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });
        if (field && field.handleChange) {
            const values = prepareValuesToSubmit();
            field.handleChange(element, field, values);
        }
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const onUpload = (inputName, file) => {
        dispatch({ type: 'SHOW_LOADING', value: false });
        let tempValues = values;
        tempValues[inputName] = file;
        updateValues(tempValues);
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const beforeUpload = element => {
        dispatch({ type: 'SHOW_LOADING', value: true });
    };

    const deleteUpload = (inputName, element) => {
        let tempValues = values;
        tempValues[inputName] = '';
        updateValues(tempValues);
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const updateMultiApiSearch = (inputName, value) => {
        let tempValues = values;
        tempValues[inputName] = value;
        updateValues(tempValues);
        if (form.validateOnChange) {
            validateForm();
        }
    }

    const deleteUploadMulti = (inputName, elementToRemove) => {
        const updatedFiles = values[inputName].filter((file) => file.files3 !== elementToRemove.files3);
        const tempValues = { ...values, [inputName]: updatedFiles };
        updateValues(tempValues);

        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleCheckBox = element => {
        let tempValues = values;
        tempValues[element.target.name] = element.target.checked ? '1' : '';
        dispatch({ type: 'UPDATE_SESSION', key: 'current_form', value: tempValues });
        if (form.validateOnChange) {
            validateForm();
        }
    };

    const handleSubmit = async (element) => {
        element.preventDefault();
        const isValid = await validateForm();
        dispatch({ type: 'SHOW_LOADING', value: true });
        if (typeof form.handleSubmit === 'function') {
            if (isValid) {
                const preparedValues = prepareValuesToSubmit();
                await form.handleSubmit(form.fields, preparedValues, form.loadData);
                await loadDataList();
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
            } else {
                Toast.error('O formulário possui erros, favor verificar.');
            }
        } else if (form.endpointSave != '') {
            if (isValid) {
                const preparedValues = prepareValuesToSubmit();
                const submitForm = async () => {
                    let response = '';
                    if (form.endpointTypeRequest == 'put') {
                        response = await Fetch.put(form.endpointSave, preparedValues);
                    } else {
                        response = await Fetch.post(form.endpointSave, preparedValues);
                    }
                    await loadDataList();
                    return response;
                }
                const response = await submitForm();
                Toast.success('Informações atualizadas com sucesso!');
                if (form.afterSubmit) {
                    form.afterSubmit(form, preparedValues, response);
                }
            } else {
                Toast.error('O formulário possui erros, favor verificar.');
            }
        }
        dispatch({ type: 'SHOW_LOADING', value: false });
    }
    const prepareValuesToLoad = (formFields, formValues) => {
        let option = {};
        for (let [key, value] of Object.entries(form.fields)) {
            let tempValue = '';
            if (formValues) {
                tempValue = formValues[value.name] ? formValues[value.name] : '';
            }
            if (form.readOnly) {
                formFields[key].readOnly = true;
            } else {
                formFields[key].readOnly = formFields[key].readOnly ? formFields[key].readOnly : false;
            }
            switch (value.type) {
                case "checkbox":
                    inputs[value.name] = tempValue ? "1" : "";
                    break;
                case "address":
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case "select":
                    option = value.options.filter((selected) => selected.value == tempValue);
                    inputs[value.name] = option.value ? option : { label: "", value: tempValue };
                    break;
                case "selectIcons":
                    option = iconsOptions.filter((selected) => selected.value == tempValue);
                    inputs[value.name] = option.value ? option : { label: "", value: tempValue };
                    break;
                case 'multiselect':
                    let multiSelectOptions = [];
                    let selectedValues = [];
                    if (formValues && formValues[value.name]) {
                        selectedValues = formValues[value.name];
                        multiSelectOptions = value.options.filter(option => (
                            selectedValues.some(selectedValue => selectedValue === option.value)
                        ));
                    }
                    inputs[value.name] = multiSelectOptions && multiSelectOptions.length > 0 ? multiSelectOptions : selectedValues;
                    break;
                case "password":
                    inputs[value.name] = "";
                    break;
                case "sourcetree":
                    inputs[value.name] = tempValue ? tempValue : [{}];
                    break;
                case "decimal":
                    inputs[value.name] = formatCurrency(tempValue);
                    break;
                case "multiApiSearch":
                    inputs[value.name] = tempValue ? tempValue : [];
                    break;
                default:
                    inputs[value.name] = tempValue ? tempValue : "";
                    break;
            }
        }
        return inputs;
    }

    const prepareValuesToSubmit = () => {
        let inputs = [];
        for (let [key, value] of Object.entries(form.fields)) {
            let tempValue = '';
            if (values) {
                tempValue = values[value.name] ? values[value.name] : '';
            }
            switch (value.type) {
                case 'checkbox':
                    inputs[value.name] = tempValue ? '1' : '';
                    break;
                case 'address':
                    inputs[value.name] = tempValue ? tempValue : {};
                    break;
                case 'select':
                    if (typeof tempValue === "object") {
                        inputs[value.name] = tempValue.value ? tempValue.value : '';
                    } else {
                        inputs[value.name] = tempValue ? tempValue : '';
                    }
                    break;
                case 'selectIcons':
                    if (typeof tempValue === "object") {
                        inputs[value.name] = tempValue.value ? tempValue.value : '';
                    } else {
                        inputs[value.name] = tempValue ? tempValue : '';
                    }
                    break;
                case 'sortabletree':
                    inputs[value.name] = session['core-sorteable-data-' + value.name]
                    break;
                case 'decimal':
                    inputs[value.name] = tempValue.replace(/\./g, '').replace(',', '.');
                    break;
                case 'multiApiSearch':
                    inputs[value.name] = tempValue ? tempValue : [];
                    break;
                default:
                    inputs[value.name] = tempValue ? tempValue : '';
                    break;
            }
        }
        inputs = { ...inputs, ...form.hiddenValues };
        if (id) {
            inputs.id = id;
        }
        return inputs;
    }

    const getSchemaValidations = () => {
        let validations = {};
        for (let [key, field] of Object.entries(form.fields)) {
            let value = { ...field };
            if (value.validations) {
                validations[value.name] = value.validations;
                if (value.validations.required) {
                    value.validations.presence = {
                        message: `^O campo ${value.label} é obrigatório`,
                        allowEmpty: false
                    }
                }

                switch (value.type) {
                    case 'phone':
                        value.validations.length = {
                            minimum: 10,
                            tooShort: ' inválido'
                        }
                        break;
                    case 'address':
                        value.validations.address = true;
                        break;
                    case 'email':
                        value.validations.email = true;
                        break;
                    case 'CNPJ':
                        value.validations.cnpj = true;
                        break;
                }
            }
            validations[value.name] = value.validations;
        }
        return validations;
    }

    const validateForm = async () => {

        const schemaValidations = getSchemaValidations();
        validate.validators.required = function (value, options, key, attributes) {
            return "";
        }

        validate.validators.address = function (value, options, key, attributes) {
            for (let [key2, value2] of Object.entries(value)) {
                if (key2 != 'complement' && value2 == '') {
                    return 'Preencha todos os campos obrigatórios de endereço.';
                }
            }
            return "";
        }

        validate.validators.cpf = function (value, options, key, attributes) {
            if (value != '' && !cpf.isValid(value)) {
                return '^CPF inválido';
            } else {
                return "";
            }
        }

        validate.validators.cnpj = function (value, options, key, attributes) {
            if (value != '' && !cnpj.isValid(value)) {
                return '^CNPJ inválido';
            } else {
                return "";
            }
        }

        validate.validators = { ...validate.validators, ...props.form.customValidators };

        let validations = undefined;
        try {
            const preparedValues = prepareValuesToSubmit();
            await validate.async(preparedValues, schemaValidations);
        } catch (error) {
            validations = error;
        }

        let validation = {};

        for (let [key, value] of Object.entries(form.fields)) {
            validation[value.name] = '';
        }
        if (validations) {
            for (let [key, value] of Object.entries(validations)) {
                validation[key] = value[0];
            }
        }
        updateErrors({ ...validation });

        return validations == undefined ? true : false;
    }

    const loadDataList = async () => {
        if (props.form.containerType == 'dialog' && props.list && props.list.endpoint) {
            let defaultRows = await Fetch.post(props.list.endpoint, { filter: props.list.filter });
            dispatch({ type: 'UPDATE_SESSION', key: props.list.key_data_rows, value: defaultRows });
        }
    }

    return (
        <form id="crudform" >
            <div className="card-body">
                <div className="row">
                    {fields && fields.map(item => {
                        let className = "form-group col-sm-12";
                        if (item.columnSize) {
                            className = 'form-group col-sm-' + item.columnSize;
                        }
                        switch (item.type) {
                            case 'label':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor="exampleInputEmail1">{item.label}</label>
                                        {item.value}
                                    </div>
                                )
                                break;
                            case 'text':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type="text"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            maxLength={item.maxLength ? item.maxLength : 80}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'email':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type="text"
                                            name={item.name}
                                            value={values[item.name]}
                                            maxLength={item.maxLength ? item.maxLength : 50}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'phone':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Phone
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'phone-international':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <PhoneInternational
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;

                            case 'password':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type="password"
                                            name={item.name}
                                            value={values[item.name]}
                                            maxLength={item.maxLength ? item.maxLength : 100}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'textarea':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type='textarea'
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            maxLength={item.maxLength ? item.maxLength : 4000}
                                            rows="5"
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'CNPJ':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <CNPJ
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'CPF':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <CPF
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'select':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Select
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={(element) => { handleChange(element, item) }}
                                            error={errors[item.name]}
                                            options={item.options}
                                            optionsEndpoint={item.optionsEndpoint}
                                            disabled={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'multiselect':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <MultiSelect
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            options={item.options}
                                            optionsEndpoint={item.optionsEndpoint}
                                            disabled={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'selectIcons':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <SelectIcons
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={(element) => { handleChange(element, item) }}
                                            error={errors[item.name]}
                                            options={iconsOptions}
                                            optionsEndpoint={item.optionsEndpoint}
                                            disabled={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'date':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <DateField
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            options={item.options}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'time':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <TimeField
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            options={item.options}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'datetime':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <DateTimeField
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            options={item.options}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'checkbox':
                                return (
                                    <div className={className} style={{ marginLeft: '20px' }} key={item.name} >
                                        <CustomCheckBox
                                            name={item.name}
                                            onChange={handleCheckBox}
                                            checked={values[item.name]}
                                            error={errors[item.name]}
                                            label={item.label}
                                            required={item.validations.required}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'address':
                                return (
                                    <div className={className} key={item.name} >
                                        <Address
                                            name={item.name}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            googleMap={item.googleMap}
                                            label={item.label}
                                            value={values[item.name]}
                                            required={item.validations.required}
                                            invalid={false}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'sortabletree':
                                return (
                                    <div className={className} key={item.name}  >
                                        <SortableTree
                                            name={item.name}
                                            onChange={handleChange}
                                            onChangeTreeData={item.onChangeTreeData}
                                            value={values[item.name]}
                                            fields={item.fieldsForm}
                                            labelNewItem={item.labelNewItem}
                                            labelTitleModal={item.labelTitleModal}
                                            wrapTitle={item.wrapTitle}
                                            customValidators={item.customValidators}
                                        />
                                    </div>
                                )
                                break;
                            case 'json':
                                return (
                                    <div className={className} key={item.name}  >
                                        <JsonInput
                                            name={item.name}
                                            onChange={handleChange}
                                            value={values[item.name]}
                                            width={item.width ? item.width : '100%'}
                                            height={item.height ? item.height : '300px'}
                                            fields={item.fieldsForm}
                                        />
                                    </div>
                                )
                                break;
                            case 'file':
                                return (
                                    <div className={className} key={item.name}  >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <FileUpload
                                            name={item.name}
                                            path={item.uploadPath}
                                            file={values[item.name]}
                                            onUpload={onUpload}
                                            onRemove={deleteUpload}
                                            beforeUpload={beforeUpload}
                                            accept={item.extensionAccept}
                                            titleButton={item.titleButton}
                                            limitFileSize={item.limitFileSize}
                                            error={errors[item.name]}
                                            disabled={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'fileS3':
                                return (
                                    <div className={className} key={item.name}  >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <FileUploadS3
                                            name={item.name}
                                            path={item.uploadPath}
                                            file={values[item.name]}
                                            onUpload={onUpload}
                                            onRemove={deleteUpload}
                                            beforeUpload={beforeUpload}
                                            accept={item.extensionAccept}
                                            titleButton={item.titleButton}
                                            limitFileSize={item.limitFileSize}
                                            error={errors[item.name]}
                                            disabled={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'multiUploadFileS3':
                                return (
                                    <div className={className} key={item.name}  >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <MultiFileUploadS3
                                            name={item.name}
                                            path={item.uploadPath}
                                            file={values[item.name]}
                                            onUpload={onUpload}
                                            onRemove={deleteUploadMulti}
                                            beforeUpload={beforeUpload}
                                            accept={item.extensionAccept}
                                            titleButton={item.titleButton}
                                            limitFileSize={item.limitFileSize}
                                            uploadFileLimit={item.uploadFileLimit}
                                            error={errors[item.name]}
                                            disabled={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'whatsappqrcode':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <WhatsAppQRCODE
                                            name={item.name}
                                            value={values[item.name]}
                                            id={item.id}
                                            endpoint={item.endpoint}
                                            endpointqrcode={item.endpointqrcode}
                                            endpointlogout={item.endpointlogout}
                                            phone_name={item.phone_name}
                                            token={item.token}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'qrcode':
                                return (
                                    <div className={className} key={item.name}>
                                        <div className="d-flex flex-column">
                                            <label>{item.label}</label>
                                            <QRCode
                                                value={item.value}
                                                size={item.size ? item.size : 100}
                                            />
                                        </div>
                                    </div>
                                )
                                break;
                            case 'multiinput':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <MultiInput
                                            name={item.name}
                                            value={values[item.name]}
                                            sortBy={item.sortBy ? item.sortBy : ''}
                                            form={item.form}
                                            id={item.id}
                                            endpoint={item.endpoint}
                                            onChange={handleChange}
                                            onAdd={handleChange}
                                            onDelete={handleChange}
                                            styleTh={item.styleTh}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'integer':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Integer
                                            type="number"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            maxLength={item.maxLength ? item.maxLength : 20}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'decimal':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Decimal
                                            type="text"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            maxLength={item.maxLength ? item.maxLength : 100}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'submit':
                                return (
                                    <div className={className} key={item.name}>
                                        <label>
                                            &nbsp;
                                        </label>
                                        <div>
                                            <button onClick={handleSubmit} type="button" className="btn btn-primary">
                                                {item.label}
                                            </button>
                                        </div>
                                    </div>
                                )
                                break;
                            case 'reset':
                                return (
                                    <div className={className} key={item.name}>
                                        <label>
                                            &nbsp;
                                        </label>
                                        <div>
                                            <button onClick={() => form.loadData({})} type="button" className="btn btn-secondary">
                                                {item.label}
                                            </button>
                                        </div>
                                    </div>
                                )
                                break;
                            case 'color':
                                return (
                                    <div className={className} key={item.name}>
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type="color"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'month':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Input
                                            type="month"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            autoFocus={item.autoFocus}
                                        />
                                    </div>
                                )
                                break;
                            case 'multiApiSearch':
                                return (
                                    <div className={className} key={item.name}  >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <MultiApiSearch
                                            onChange={updateMultiApiSearch}
                                            name={item.name}
                                            value={values[item.name]}
                                            endpoint_method={item.endpoint_method}
                                            endpoint_filter={item.endpoint_filter}
                                            endpoint={item.endpoint}
                                            response_type={item.response_type}
                                            label_column={item.label_column}
                                            label_path={item.label_path}
                                            value_path={item.value_path}
                                            required_input_search={item.required_input_search}
                                            titleButton={item.titleButton}
                                            error={errors[item.name]}
                                            disabled={item.readOnly ? true : false}
                                        />
                                    </div>
                                )
                                break;
                            case 'year':
                                return (
                                    <div className={className} key={item.name} >
                                        <label htmlFor={'id_' + item.name} >
                                            {item.label}
                                        </label>
                                        {item.validations.required && (
                                            <span className="required"> *</span>
                                        )}
                                        <Year
                                            type="number"
                                            name={item.name}
                                            value={values[item.name]}
                                            onChange={handleChange}
                                            error={errors[item.name]}
                                            readOnly={item.readOnly ? true : false}
                                            selectable={item.selectable || false}
                                        />
                                    </div>
                                )
                                break;
                        }
                    })}
                </div>

            </div>
            {/* /.card-body */}
            {form.showContainerButtons && (
                (form.containerType == 'container') ? (
                    <div className="card-footer d-flex justify-content-end">
                        {form.showGoBackButton && (
                            <button onClick={goBack} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                Voltar
                            </button>
                        )}
                        {form.showSubmitButton && (<button onClick={handleSubmit} type="button" className="btn btn-primary">Enviar</button>)}
                    </div>
                ) : (
                    <Modal.Footer>
                        {form.showGoBackButton && (
                            <button onClick={goBack} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                Voltar
                            </button>
                        )}
                        {form.showSubmitButton && (<button onClick={handleSubmit} type="button" className="btn btn-primary">Enviar</button>)}
                    </Modal.Footer>
                )
            )}
        </form>
    );
}

export default CustomForm;